import { useQuery } from "@tanstack/react-query";
import { Instagram, Menu, Music2, ShoppingBag, X } from "lucide-react";
import { useState } from "react";
import { Link, NavLink, Outlet } from "react-router-dom";

import { storeQueries } from "../lib/api";
import { useCart } from "../lib/cart";

export function useStorefront() {
  return useQuery({ queryKey: ["storefront"], queryFn: storeQueries.storefront, staleTime: 30_000 });
}

export function SiteShell() {
  const { data } = useStorefront();
  const { count } = useCart();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="site-shell">
      <a className="skip-link" href="#main-content">Skip to content</a>
      <div className="announcement">{data?.settings.announcement ?? "Made by hand, just for you."}</div>
      <header className="site-header">
        <button className="icon-button menu-button" onClick={() => setMenuOpen(true)} aria-label="Open menu">
          <Menu aria-hidden="true" />
        </button>
        <Link className="wordmark" to="/" aria-label="Anne Cosette home">
          <span>Anne</span><span>Cosette</span>
        </Link>
        <nav className="desktop-nav" aria-label="Main navigation">
          <NavLink to="/shop">Shop all</NavLink>
          {data?.categories.map((category) => (
            <NavLink key={category.id} to={`/shop/${category.slug}`}>{category.name}</NavLink>
          ))}
          <NavLink to="/contact">Contact</NavLink>
        </nav>
        <Link className="cart-link" to="/cart" aria-label={`Shopping bag with ${count} items`}>
          <ShoppingBag aria-hidden="true" /><span>{count}</span>
        </Link>
      </header>

      <div className={`mobile-drawer ${menuOpen ? "open" : ""}`} aria-hidden={!menuOpen}>
        <button className="icon-button drawer-close" onClick={() => setMenuOpen(false)} aria-label="Close menu"><X /></button>
        <nav aria-label="Mobile navigation">
          <NavLink onClick={() => setMenuOpen(false)} to="/shop">Shop all</NavLink>
          {data?.categories.map((category) => (
            <NavLink onClick={() => setMenuOpen(false)} key={category.id} to={`/shop/${category.slug}`}>{category.name}</NavLink>
          ))}
          <NavLink onClick={() => setMenuOpen(false)} to="/contact">Contact</NavLink>
          <NavLink onClick={() => setMenuOpen(false)} to="/shipping">Shipping</NavLink>
          <NavLink onClick={() => setMenuOpen(false)} to="/returns">Returns</NavLink>
        </nav>
      </div>
      {menuOpen && <button className="drawer-backdrop" onClick={() => setMenuOpen(false)} aria-label="Close menu overlay" />}

      <main id="main-content"><Outlet /></main>
      <footer className="site-footer">
        <div className="footer-wordmark">Anne Cosette</div>
        <div className="footer-links">
          <Link to="/shop">Shop</Link><Link to="/shipping">Shipping</Link><Link to="/returns">Returns</Link><Link to="/contact">Contact</Link>
        </div>
        <div className="social-links">
          {data?.settings.instagram_url && <a href={data.settings.instagram_url} target="_blank" rel="noreferrer" aria-label="Instagram"><Instagram /></a>}
          {data?.settings.tiktok_url && <a href={data.settings.tiktok_url} target="_blank" rel="noreferrer" aria-label="TikTok"><Music2 /></a>}
        </div>
        <p>© {new Date().getFullYear()} Anne Cosette. Made with joy.</p>
        <Link className="admin-link" to="/admin">Store manager</Link>
      </footer>
    </div>
  );
}

